import { useEffect, useRef, useState } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { X } from 'lucide-react';

export default function ReferenceEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, selected, data }) {
  const [hovered, setHovered] = useState(false);
  const leaveTimerRef = useRef(null);
  useEffect(() => () => window.clearTimeout(leaveTimerRef.current), []);
  const span = Math.abs(targetX - sourceX);
  const [bezierPath, bezierLabelX, bezierLabelY] = getBezierPath({
    sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition,
    curvature: Math.max(0.16, Math.min(0.32, 150 / Math.max(150, span))),
  });
  // Keep every connection on the same soft Bezier curve.  Straight single
  // input lines looked rigid and made the canvas feel disconnected.
  const path = bezierPath;
  const labelX = bezierLabelX;
  const labelY = bezierLabelY;
  const phase = [...String(id)].reduce((sum, character) => sum + character.charCodeAt(0), 0) % 23;
  const enter = () => {
    window.clearTimeout(leaveTimerRef.current);
    setHovered(true);
  };
  const leave = () => {
    window.clearTimeout(leaveTimerRef.current);
    leaveTimerRef.current = window.setTimeout(() => setHovered(false), 120);
  };
  return (
    <>
      <g className={`canvas-edge ${selected ? 'is-selected' : ''}`} data-edge-id={id} style={{ '--edge-phase': `${-phase / 11}s` }} onMouseEnter={enter} onMouseLeave={leave}>
        <BaseEdge id={`${id}-hit`} path={path} className="canvas-edge__hit" />
        <BaseEdge id={`${id}-tube`} path={path} className="canvas-edge__tube" />
        <BaseEdge id={`${id}-energy`} path={path} className="canvas-edge__energy" />
        <BaseEdge id={`${id}-spark`} path={path} className="canvas-edge__spark" />
      </g>
      <EdgeLabelRenderer>
        {(hovered || selected) && <button
          type="button"
          className="canvas-edge-delete nodrag nopan"
          aria-label="删除连线"
          title="取消参考连接"
          style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
          onMouseEnter={enter}
          onMouseLeave={leave}
          onPointerDown={(event) => { event.preventDefault(); event.stopPropagation(); }}
          onClick={(event) => { event.preventDefault(); event.stopPropagation(); data?._delete?.(id); }}
        ><X size={13} /></button>}
      </EdgeLabelRenderer>
    </>
  );
}
